import {getCsrfAndSessionToken} from './helpers';

window.giftSubscriptions = {
    /**
     * Submit Account Form
     *
     * @param event
     */
    submit: function (event) {
        event.preventDefault();

        //
        // Set Loading
        //
        jQuery('[data-gift-subscription-cloak]').fadeIn();

        //
        // Clear Error Messages
        //
        let errorMapping = {
            'duration': 'duration',
            'sender_first_name': 'sender-first-name',
            'sender_last_name': 'sender-last-name',
            'sender_email': 'sender-email',
            'recipient_email': 'recipient-email',
            'recipient_first_name': 'recipient-first-name',
            'recipient_last_name': 'recipient-last-name',
            'delivery_date': 'delivery-date',
            'delivery_time': 'delivery-time',
            'message': 'message',
            'marketing_consent': 'marketing-consent',
        };

        for (let i = 0; i < Object.keys(errorMapping).length; i++) {
            let value = errorMapping[Object.keys(errorMapping)[i]];
            document.querySelector('[data-error-' + value +']').style.display = 'none';
            document.querySelector('[data-error-' + value +']').innerText = '';
        }

        getCsrfAndSessionToken()
            .then((token) => {
                return new Promise((resolve, reject) => {
                    fetch(window.loginEndpoint + '/gift/checkout', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-XSRF-TOKEN': token,
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            duration: document.querySelector('[data-input-duration]').value,
                            sender_first_name: document.querySelector('[data-input-sender-first-name]').value,
                            sender_last_name: document.querySelector('[data-input-sender-last-name]').value,
                            sender_email: document.querySelector('[data-input-sender-email]').value,
                            recipient_email: document.querySelector('[data-input-recipient-email]').value,
                            recipient_first_name: document.querySelector('[data-input-recipient-first-name]').value,
                            recipient_last_name: document.querySelector('[data-input-recipient-last-name]').value,
                            delivery_date: document.querySelector('[data-input-delivery-date]').value,
                            delivery_time: document.querySelector('[data-input-delivery-time]').value,
                            message: document.querySelector('[data-input-message]').value,
                            marketing_consent: document.querySelector('[data-input-marketing-consent]').value,
                        }),
                    })
                        .then(response => {
                            if (response.ok) {
                                //
                                // Redirect
                                //
                                response.json().then(data => {
                                    window.location.href = data.redirect;
                                })
                                    .catch((errors) => {
                                        console.error('Error:', errors);
                                    });

                                console.log(response);
                                resolve();
                            } else {
                                response.json().then(data => {
                                    console.log(data.errors, errorMapping);
                                    for (let i = 0; i < Object.keys(errorMapping).length; i++) {
                                        let key = Object.keys(errorMapping)[i];
                                        let value = errorMapping[Object.keys(errorMapping)[i]];

                                        if (key in data.errors) {
                                            let message = data.errors[key].join('. ');
                                            document.querySelector('[data-error-' + value +']').style.display = 'block';
                                            document.querySelector('[data-error-' + value +']').innerText = message
                                        }
                                    }
                                })
                                    .catch((errors) => {
                                        console.error('Error:', errors);
                                    });

                                //
                                // If we received errors, present them
                                //
                                /**/

                                reject();
                                //
                                // Set Loading
                                //
                                jQuery('[data-gift-subscription-cloak]').fadeOut();
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                            reject();
                            //
                            // Set Loading
                            //
                            jQuery('[data-gift-subscription-cloak]').fadeOut();
                        });
                });
            })
            .catch(() => {
                //
                // Set Loading
                //
                jQuery('[data-gift-subscription-cloak]').fadeOut();
            })
    },
}
